import { HTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './healthcare-description.module.css';

export interface DescriptionProps extends HTMLAttributes<HTMLDivElement> {
  text: string;
  title: string;
}

export default function HealthcareDescription({
  text,
  title,
  className,
  ...props
}: DescriptionProps) {
  return (
    <div {...props} className={cn(styles.description, className)}>
      <h4 className={styles.description__title}>{title}</h4>
      <p className={styles.description__text}>{text}</p>
    </div>
  );
}
